import { render, staticRenderFns } from "./HomeNatrix.vue?vue&type=template&id=7c90259c&scoped=true"
import script from "./HomeNatrix.vue?vue&type=script&lang=js"
export * from "./HomeNatrix.vue?vue&type=script&lang=js"
import style0 from "./HomeNatrix.vue?vue&type=style&index=0&id=7c90259c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90259c",
  null
  
)

export default component.exports